import Vue from 'vue';
import {indexOf, map} from 'lodash';
import {createBuilding, loadBuildings, removeBuilding, updateBuilding} from '../modules/api/building.api';
import {updateBuildingImages} from '../modules/api/building.api';

function initialState() {
    return {
        buildings: [],
    }
}

const getters = {
    buildings:                (state) => state.buildings,
    buildingsForAutocomplete: (state) => state.buildings.map(({ id, title }) => {
        return { name: title, id };
    }),
    loadBuildingById:         (state, getters) => (buildingId) => {
        return new Promise((resolve) => resolve(getters.buildings.find((building) => building.id === buildingId) || null));
    },
}

const actions = {
    async createBuilding({ commit, rootGetters }, data) {
        const projectId = rootGetters['projects/project/projectId'];
        return createBuilding({ ...data, projectId }).then((data) => commit('ADD_BUILDING', data))
    },
    async updateBuilding({ commit }, data) {
        return updateBuilding(data).then((data) => commit('UPDATE_BUILDING', data))
    },
    async removeBuilding({ commit }, buildingId) {
        return removeBuilding(buildingId).then(() => commit('REMOVE_BUILDING', buildingId))
    },
    async loadBuildings({ commit, rootGetters }) {
        const projectId = rootGetters['projects/project/projectId'];
        return loadBuildings(projectId).then((data) => commit('SET_BUILDINGS', data));
    },

    // IMAGES

    async updateImages({ commit, getters, rootGetters }, data) {
        const images = rootGetters['media/images'];
        const { buildingId } = data;
        return updateBuildingImages({ ...data, id: buildingId })
        .then((data) => commit('UPDATE_IMAGES', { ...data, images, buildingId }));
    },
    async removeImages({ dispatch }, data) {
        return dispatch('updateImages', { ...data, connected: false });
    },

    reset: ({ commit }) => commit('RESET'),
}

const mutations = {
    SET_BUILDINGS:   (state, buildingsData) => state.buildings = buildingsData,
    ADD_BUILDING:    (state, buildingData) => state.buildings.push(buildingData),
    UPDATE_BUILDING: (state, buildingData) => {
        const index = indexOf(map(state.buildings, (object) => object.id), buildingData.id);
        Vue.set(state.buildings, index, buildingData);
    },
    REMOVE_BUILDING: (state, buildingId) => {
        const index = indexOf(map(state.buildings, (object) => object.id), buildingId);
        if (index !== -1) {
            state.buildings.splice(index, 1);
        }
    },

    // IMAGES

    UPDATE_IMAGES: (state, data) => {
        const { connected, imageIds, buildingId, images } = data;
        const clear = data.hasOwnProperty('clear');

        const building = state.buildings.find(({ id }) => id === buildingId) || null;
        const buildingIndex = indexOf(map(state.buildings, (object) => object.id), buildingId);

        if (null === building) return;

        if (clear) {
            building.images = [];
        }
        imageIds.map((imageId) => {
            const image = images.find(({ id }) => id === imageId) || null
            if (null !== image) {
                if (clear) {
                    building.images.push(image);
                } else {
                    const index = indexOf(map(building.images, (object) => object.id), imageId);

                    if (connected && index === -1) {
                        building.images.push(image);
                    }
                    if (false === connected && index !== -1) {
                        building.images.splice(index, 1);
                    }
                }
            }
        });
        Vue.set(state.buildings, buildingIndex, building);
    },

    RESET: (state) => {
        const s = initialState();
        Object.keys(s).forEach(key => state[key] = s[key]);
    }
}

export default {
    namespaced: true,
    state:      initialState,
    getters,
    actions,
    mutations
}
